import script from "./PickList.vue?vue&type=script&setup=true&lang=js"
export * from "./PickList.vue?vue&type=script&setup=true&lang=js"

import "./PickList.vue?vue&type=style&index=0&id=1785c63b&lang=css"

const __exports__ = script;

export default __exports__